<template>
    <van-dialog v-model:show="$store.state.vipDialog" class="vipDialog" style="width: 95%;max-width:520px;background-image: linear-gradient(180deg, #FBFEFE 0%, #AEDAFE 100%)!important;border-radius: 20px!important;overflow: visible;" closeOnClickOverlay>
      <div class="vipDialogtop">
        <img v-if="!$store.state.vipDialogType" :src="require('@/assets/img/mineHealth/viptop1.png')">
        <img v-else :src="require('@/assets/img/mineHealth/viptop.png')">
      </div>
      <div class="vipDialogCon1">
        <div v-for="(item, i) in $store.state.wechatPayGoodsInfoTop" :key="i" @click="chooseVipDialogTop(item, i)" :class="{ vipDialogConactiveTop: i === $store.state.activeIndexTop }">
            <div class="vipDialogCon_card_goodsDetail" v-if="i === $store.state.activeIndexTop">当前选择</div>
            <img :src="require('@/assets/img/mineHealth/vip'+item.goodsType +'.png')">
            <div class="vipDialogCon_card_name">{{ item.goodsTypeName }}</div>
        </div>
      </div>
      <div class="vipDialogCon">
        <div :class="{ vipDialogConactive11: $store.state.activeIndexTop === 1 }">
          <div v-for="(item, i) in $store.state.wechatPayGoodsInfo" :key="i" @click="chooseVipDialog(item, i)" :class="{ vipDialogConactive: i === $store.state.activeIndexVip }">
            <div :class="{ vipDialogConactive1: i === $store.state.activeIndexVip }">
              <div class="vipDialogCon_card_goodsDetail" v-if="item.goodsDetail != ''">{{ item.goodsDetail }}</div>
              <div class="vipDialogCon_card_name">{{ item.goodsName }}</div>
              <div class="vipDialogCon_card_price">
                <div><span>¥</span>{{ item.price }}</div>
              </div>
            </div>
            <p :class="{ vipDialogConactive2: i === $store.state.activeIndexVip }" v-if="item.goodsPointPic != ''">赠送{{ item.goodsPointPic }}会员点数</p>
          </div>
        </div>
      </div>

      <!-- 用户须知确认区域 -->
      <div class="user-notice-wrapper">
        <van-checkbox v-model="isAgreed" checked-color="#3E70ED" class="agree-checkbox">
          <div class="notice-agreement">
            <span>我已阅读并同意</span>
            <span class="notice-link" @click.stop="showNoticeDialog">《会员服务协议与用户须知》</span>
          </div>
        </van-checkbox>
      </div>

      <template #footer>
        <div class="vipDialogBtn" >
          <div type="primary" @click="handlePayClick">立即支付</div>
        </div>
      </template>
    </van-dialog>

    <!-- 用户须知弹窗 -->
    <van-popup v-model:show="showNotice" position="bottom" round :style="{ height: '85%', padding: '0' }" class="notice-popup-wrapper">
      <div class="notice-popup">
        <div class="notice-header">
          <div class="notice-title">用户须知</div>
          <van-icon name="cross" size="20" @click="closeNoticeDialog" class="close-icon" />
        </div>

        <div class="notice-content">
          <div class="notice-intro">
            亲爱的用户：欢迎使用我们的 "AI智聊盒"！为了让您的使用过程更顺畅，避免因信息误解带来困扰，请您仔细阅读以下核心规则与服务说明：
          </div>

          <div class="notice-section">
            <h4 class="section-title">一、会员权益说明</h4>
            <ul class="notice-list">
              <li><span class="highlight">「充值会员解锁AI工具」是正常服务规则。</span>提交订单前，请仔细核对订单金额、购买周期、服务内容，避免误操作支付非必要费用。</li>
              <li>课程学员使用时，请先与授课老师确认是否包含AI工具使用权益，再行支付。</li>
              <li>本应用实行 <span class="highlight">"会员 + 积分" 双轨制</span>，请按需购买。AI 聊天、AI 写作等属于会员特权；AI 生图、AI 生视频按次消耗积分。<span class="highlight">7 天试用期结束后，会员服务将自动转为付费模式。</span></li>
            </ul>
          </div>

          <div class="notice-section">
            <h4 class="section-title">二、商品交付与效果</h4>
            <ul class="notice-list">
              <li><span class="highlight">服务性质明确本程序仅提供线上功能类产品</span>，支付成功后可在用户模块查询会员/积分到账情况。无任何实物邮寄服务。</li>
              <li>如由于网络波动，导致支付未及时到账，请刷新后再次查询/联系客服及时处理。</li>
            </ul>
          </div>

          <div class="notice-section">
            <h4 class="section-title">三、售后服务指引</h4>
            <ul class="notice-list">
              <li><span class="highlight">退款规则说明本程序支持 7 天无理由退款</span>，因个人操作失误（如误下单、混淆订单、未按指引操作等）导致的问题，我们仍会按流程为您办理退款。</li>
              <li><span class="highlight">问题排查</span>遇到支付未到账、功能异常等问题时，请先尝试刷新页面、重启本程序，或在对应功能模块（如「积分中心」）查询状态；若仍未解决，再联系客服处理。</li>
              <li><span class="highlight">账户安全提醒</span>请您妥善保管账户密码，若发现非本人操作的支付，可能是账户被盗用导致，建议您立即修改密码并联系平台协助核实。</li>
            </ul>
          </div>

          <div class="notice-section">
            <h4 class="section-title">四、营销说明</h4>
            <ul class="notice-list">
              <li>可能会对注册手机号发送营销信息。如：您不希望接收相关资讯，可回复"TD"退订。<span class="highlight">营销信息仅用于产品更新、优惠活动及服务通知等内容推送，不会泄露您的个人信息。</span></li>
              <li><span class="highlight">平台承诺遵守隐私政策，保护用户通信秘密</span>，未经许可不向第三方共享手机号码等注册信息。所有营销行为均符合法律法规要求。</li>
            </ul>
          </div>

          <div class="notice-tips">
            <van-icon name="warning" color="#FF6B00" size="16" />
            <span>请仔细阅读以上内容，确认无误后再进行购买操作</span>
          </div>
        </div>

        <div class="notice-footer">
          <van-button type="primary" block round @click="agreeNotice" class="agree-btn">我已阅读并同意</van-button>
        </div>
      </div>
    </van-popup>
</template>

<script>
import { getMemberfo, paymentList, wechatPayCreateOrder, wechatPayGetOrder } from '@/api/apis';
import { showDialog, showConfirmDialog } from 'vant';
import wx from 'weixin-js-sdk';
export default {
  props: {
  },
  data () {
    return {
      chooseVipDialogInfo: {},
      count: 0,
      maxCount: 3, // 设定循环次数
      isAgreed: false, // 是否同意用户须知
      showNotice: false // 是否显示用户须知弹窗
    };
  },
  created () {
    this.chooseVipDialogInfo = this.$store.state.wechatPayGoodsInfo[this.$store.state.activeIndexVip];
    console.log(222222222222222, this.chooseVipDialogInfo, this.$store.state.activeIndexVip);
  },
  mounted () {
  },
  methods: {
    chooseVipDialogTop (item, i) {
      this.$store.dispatch('changeStoreData', { key: 'activeIndexTop', value: i });
      this.$store.dispatch('changeStoreData', { key: 'wechatPayGoodsInfo', value: this.$store.state.wechatPayGoodsInfoTop[i].list });
      this.chooseVipDialogInfo = this.$store.state.wechatPayGoodsInfo[this.$store.state.activeIndexVip];
    },
    chooseVipDialog (item, i) {
      this.$store.dispatch('changeStoreData', { key: 'activeIndexVip', value: i });
      this.chooseVipDialogInfo = item;
    },
    // 显示用户须知弹窗
    showNoticeDialog () {
      this.showNotice = true;
    },
    // 关闭用户须知弹窗
    closeNoticeDialog () {
      // 关闭时不改变复选框状态，保持原来的状态
      this.showNotice = false;
    },
    // 同意用户须知
    agreeNotice () {
      this.isAgreed = true;
      this.showNotice = false;
    },
    // 立即支付点击处理
    handlePayClick () {
      if (!this.isAgreed) {
        // 创建一个自定义弹窗，避免HTML样式问题
        const dialog = showConfirmDialog({
          title: '付费服务协议',
          message: '为保证您的合法权益，请阅读并同意《会员服务协议与用户须知》后再进行支付！',
          showCancelButton: true,
          cancelButtonText: '取消',
          confirmButtonText: '同意并购买',
          theme: 'round-button',
          confirmButtonColor: '#3E70ED',
          cancelButtonColor: '#999'
        });

        // 在对话框显示后，找到消息元素并修改其中的链接部分
        dialog.then(() => {
          // 同意并购买
          this.isAgreed = true;
          this.getWechatPayCreateOrder();
        }).catch(() => {
          // 取消
          console.log('用户取消');
        });

        // 等待对话框渲染完成后修改链接样式
        setTimeout(() => {
          const dialogElement = document.querySelector('.van-dialog__message');
          if (dialogElement) {
            // 将普通文本转换为可点击的链接
            const originalText = dialogElement.textContent;
            const newHtml = originalText.replace(
              /《会员服务协议与用户须知》/,
              '<span class="dialog-notice-link" style="color: #3E70ED; font-weight: 500; cursor: pointer; position: relative; text-decoration: none;">《会员服务协议与用户须知》</span>'
            );

            dialogElement.innerHTML = newHtml;

            // 添加下划线伪元素（通过CSS变量控制）
            const style = document.createElement('style');
            style.textContent = `
              .dialog-notice-link::after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 1px;
                background: #3E70ED;
                transform: scaleX(0.9);
                opacity: 0.7;
              }
            `;
            document.head.appendChild(style);

            // 添加点击事件
            const linkElement = dialogElement.querySelector('.dialog-notice-link');
            if (linkElement) {
              linkElement.addEventListener('click', (e) => {
                e.stopPropagation();
                const dialogInstance = document.querySelector('.van-dialog');
                if (dialogInstance) {
                  // 查找关闭按钮并点击
                  const closeBtn = dialogInstance.querySelector('.van-dialog__cancel');
                  if (closeBtn) {
                    closeBtn.click();
                  }
                }
                // 延迟打开用户须知弹窗
                setTimeout(() => {
                  this.showNoticeDialog();
                }, 100);
              });
            }
          }
        }, 100);

        return;
      }
      this.getWechatPayCreateOrder();
    },
    // 支付下单
    getWechatPayCreateOrder () {
      console.log(33333333333, this.chooseVipDialogInfo);
      let getUserInfoParam = {
        sessionId: this.$cookies.get('sessionId'),
        id: this.chooseVipDialogInfo.id
      };
      wechatPayCreateOrder(getUserInfoParam, this).then((res) => {
        console.log(res);
        this.outTradeNo = res.outTradeNo;
        const that = this;
        let paymentParams = {
          appId: res.appId,
          timeStamp: res.timeStamp,
          nonceStr: res.nonceStr,
          package: res.packageVal,
          signType: res.signType, // 微信签名方式：
          paySign: res.paySign // 微信签名
        };
        console.log('进入ready', paymentParams);
        wx.invoke(
          'getBrandWCPayRequest',
          paymentParams,
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // Payment successful
              console.log('Payment successful!');
              setTimeout(() => {
                this.$store.dispatch('changeStoreData', { key: 'vipDialog', value: false });
                that.getWechatPayGetOrder();
              }, 1000); // 1000毫秒 = 1秒
            } else {
              // Payment failed
              console.log('Payment failed: ' + res.err_msg);
            }
          }
        );
      });
    },
    // 获取订单支付状态
    getWechatPayGetOrder () {
      let getUserInfoParam = {
        sessionId: this.$cookies.get('sessionId'),
        outTradeNo: this.outTradeNo
      };
      wechatPayGetOrder(getUserInfoParam, this).then((res) => {
        if (res.payStatus === 1) {
          this.count = 0;
          showDialog({
            title: '温馨提示',
            message: '订单支付成功',
            theme: 'round-button',
            confirmButtonColor: '#3E70ED'
          }).then(() => {
            this.getUserInfoParam();
          });
          return;
        } else if (res.payStatus === 2 || res.payStatus === 3) {
          this.count = 0;
          showDialog({
            title: '温馨提示',
            message: res.tradeMsg,
            theme: 'round-button',
            confirmButtonColor: '#3E70ED'
          }).then(() => {
          });
          return;
        } else if (res.payStatus === 0) {
          console.log(this.count, this.maxCount);
          if (this.count < this.maxCount) {
            this.count = this.count + 1;
            this.getPayGetOrder();
          } else {
            this.count = 0;
            showDialog({
              title: '温馨提示',
              message: '订单支付超时',
              theme: 'round-button',
              confirmButtonColor: '#3E70ED'
            }).then(() => {
            });
            return;
          }
        };
      });
    },
    getPayGetOrder () {
      const that = this;
      setTimeout(() => {
        that.getWechatPayGetOrder();
      }, 1000); // 1000毫秒 = 1秒
    },
    // 获取支付记录
    getPaymentList () {
      let getUserInfoParam = {
        sessionId: this.$cookies.get('sessionId')
      };
      paymentList(getUserInfoParam, this).then((res) => {
        this.getUserInfoParam();
      });
    },
    // 获取会员信息
    getUserInfoParam () {
      let getUserInfoParam = {
        sessionId: this.$cookies.get('sessionId')
      };
      getMemberfo(getUserInfoParam, this).then((res) => {
        sessionStorage.setItem('memberInfo', JSON.stringify(res));
        this.$store.dispatch('changeStoreData', { key: 'memberInfo', value: res });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.vipDialog{
  .vipDialogtop{
    width: 100%;
    height: 135px;
    position: relative;
    top: -15px;
    z-index: 1111;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .vipDialogCon1{
    display: flex;
    justify-content: space-between;
    padding:0 10px;
    width: 100%;
    box-sizing: border-box;
    margin: 10px 0 10px 0;
    >div{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 46%;
      background: #E3F0F8;
      border: 1px solid #E3F0F8;
      padding:2px;
      border-radius: 10px;
      height: 55px;
      font-family: PingFang-SC-Bold;
      font-weight: 700;
      font-size: 16px;
      color: #1C2023;
      letter-spacing: 0;
      text-align: center;
      position: relative;
      .vipDialogCon_card_goodsDetail{
          position: absolute;
          top: 0px;
          right: 0px;
          font-size: 12px;
          padding: 2px 5px;
          background-image: linear-gradient(-89deg, #A9D8F8 3%, #4285FF 96%);
          border-radius: 0 10px 0 10px;
          font-family: PingFang-SC-Bold;
          font-weight: 700;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
        }
    }
    img{
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .vipDialogConactiveTop{
      border: 1px solid #3E70ED;
    }
  }
  .vipDialogCon{
    overflow-x: auto;
    position: relative;
    .vipDialogConactive11{
      width: 560px;
    }
    >div{
      display: flex;
      justify-content: space-between;
      padding:0 10px;
      width: 100%;
      box-sizing: border-box;
      margin: 10px 0 10px 0;
      width: 430px;
      >div{
        width: 125px;
        background-image: linear-gradient(180deg, #E9F5FE 0%, #FFFFFF 100%);
        border-radius: 20px;
        padding:2px 2px 10px 2px;
        border-radius: 10px;
        height: 160px;
        >div{
          padding: 10px 2px 8px 2px;
          border-radius: 10px;
          position: relative;
        }
        .vipDialogCon_card_goodsDetail{
            position: absolute;
            top: -8px;
            right: -2px;
            font-size: 13px;
            padding: 2px 5px;
            background-image: linear-gradient(270deg, #FDE7BC 3%, #F67852 100%);
            border-radius: 25px 25px 25px 0;
            font-family: PingFang-SC-Bold;
            font-weight: 700;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
          }
        .vipDialogCon_card_name{
          padding-top: 5px;
          font-size: 15px;
          height: 35px;
          font-family: PingFang-SC-Bold;
          font-weight: 700;
          color: #1C2023;
          letter-spacing: 0;
          text-align: center;
        }
        .vipDialogCon_card_price{
          font-size: 28px;
          text-align: center;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin-top: 10px;
          font-family: PingFang-SC-Bold;
          font-weight: 700;
          color: #3E70ED;
          letter-spacing: 0;
          span{
            font-family: PingFang-SC-Bold;
            font-weight: 700;
            font-size: 15px;
            color: #3E70ED;
            letter-spacing: 0;
            margin-right: 4px;
          }
        }
        >p{
          font-size: 13px;
          text-align: center;
          height: 30px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #1C2023;
          padding-top: 9px;
        }
      }
    }
    .vipDialogConactive{
      background-image: linear-gradient(-87deg, #A9D8F8 3%, #4285FF 96%)!important;
    }
    .vipDialogConactive1{
      background: #FFFFFF!important;
    }
    .vipDialogConactive2{
      color: #FFFFFF!important;
    }
  }
  .vipDialogCon::-webkit-scrollbar {
    width: 0;
  }
  .vipDialogtext{
    padding: 6px 10px;
    p{
      font-family: PingFang-SC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #1C2023;
      letter-spacing: 0;
    }
  }

  /* 用户须知确认区域 - 新样式 */
  .user-notice-wrapper {
    padding: 10px 15px 5px;

    .agree-checkbox {
      width: 100%;

      :deep(.van-checkbox__icon) {
        font-size: 16px;
      }

      :deep(.van-checkbox__label) {
        font-size: 14px;
        color: #666;
      }
    }

    .notice-agreement {
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;

      .notice-link {
        color: #3E70ED;
        font-weight: 500;
        margin-left: 4px;
        cursor: pointer;
        text-decoration: none;
        position: relative;

        &:after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 1px;
          background: #3E70ED;
          transform: scaleX(0.9);
          opacity: 0.7;
        }

        &:hover {
          color: #2A5FD6;
        }
      }
    }
  }

  .vipDialogBtn{
    padding: 10px;
    div{
      width: 100%;
      height: 30px;
      line-height: 30px;
      padding: 10px 0;
      text-align: center;
      margin: 10px 0 5px 0;
      border-radius: 12px;
      background: linear-gradient(135deg, #3E70ED 0%, #5A8CFF 100%);
      font-size: 17px;
      font-family: PingFang-SC-Bold;
      font-weight: 700;
      color: #FFFFFF;
      letter-spacing: 0;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(62, 112, 237, 0.2);

      &:active {
        transform: translateY(1px);
        box-shadow: 0 2px 6px rgba(62, 112, 237, 0.2);
      }

      &.disabled {
        background: linear-gradient(135deg, #CCD3E3 0%, #E1E6F0 100%);
        cursor: not-allowed;
        box-shadow: 0 4px 8px rgba(204, 211, 227, 0.3);

        &:active {
          transform: none;
          box-shadow: 0 4px 8px rgba(204, 211, 227, 0.3);
        }
      }
    }
  }
}

/* 用户须知弹窗样式 - 新设计 */
.notice-popup-wrapper {
  overflow: hidden;

  .notice-popup {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;

    .notice-header {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 20px 15px;
      position: relative;
      border-bottom: 1px solid #F0F0F0;

      .notice-title {
        font-family: PingFang-SC-Bold;
        font-weight: 700;
        font-size: 18px;
        color: #1C2023;
        letter-spacing: 0;
        text-align: center;
      }

      .close-icon {
        position: absolute;
        right: 20px;
        top: 20px;
        color: #999;
        cursor: pointer;
        padding: 4px;
        border-radius: 50%;
        background: #F5F5F5;

        &:hover {
          background: #EEEEEE;
        }
      }
    }

    .notice-content {
      flex: 1;
      overflow-y: auto;
      padding: 20px;

      .notice-intro {
        background: linear-gradient(135deg, #F8FAFF 0%, #F0F7FF 100%);
        border-left: 4px solid #3E70ED;
        padding: 15px;
        border-radius: 8px;
        margin-bottom: 20px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        font-size: 15px;
        color: #1C2023;
        line-height: 1.5;
      }

      .notice-section {
        margin-bottom: 20px;

        .section-title {
          font-family: PingFang-SC-Bold;
          font-weight: 700;
          font-size: 16px;
          color: #1C2023;
          margin-bottom: 10px;
          padding-left: 8px;
          position: relative;

          // &:before {
          //   content: '';
          //   position: absolute;
          //   left: 0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   width: 4px;
          //   height: 16px;
          //   background: #3E70ED;
          //   border-radius: 2px;
          // }
        }

        .notice-list {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            position: relative;
            padding-left: 18px;
            margin-bottom: 10px;
            font-family: PingFang-SC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #555;
            line-height: 1.6;

            &:before {
              content: '•';
              position: absolute;
              left: 0;
              color: #3E70ED;
              font-weight: bold;
            }

            .highlight {
              color: #1C2023;
              font-weight: 600;
              background: linear-gradient(120deg, #FFF9E6 0%, #FFF9E6 100%);
              padding: 0 4px;
              border-radius: 2px;
              // border-left: 2px solid #FFC107;
            }
          }
        }
      }

      .notice-tips {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFF9F0;
        border: 1px solid #FFE7CC;
        border-radius: 8px;
        padding: 12px;
        margin-top: 20px;

        span {
          margin-left: 8px;
          font-family: PingFang-SC-Medium;
          font-weight: 500;
          font-size: 14px;
          color: #FF6B00;
        }
      }
    }

    .notice-footer {
      padding: 15px 20px 20px;
      border-top: 1px solid #F0F0F0;
      background: #FFFFFF;

      .agree-btn {
        height: 48px;
        background: linear-gradient(135deg, #3E70ED 0%, #5A8CFF 100%);
        border: none;
        border-radius: 12px;
        font-family: PingFang-SC-Bold;
        font-weight: 700;
        font-size: 16px;
        color: #FFFFFF;
        box-shadow: 0 4px 12px rgba(62, 112, 237, 0.2);

        &:active {
          transform: translateY(1px);
          box-shadow: 0 2px 6px rgba(62, 112, 237, 0.2);
        }
      }
    }
  }
}

/* 美化滚动条 */
.notice-content::-webkit-scrollbar {
  width: 6px;
}

.notice-content::-webkit-scrollbar-track {
  background: #F5F5F5;
  border-radius: 3px;
}

.notice-content::-webkit-scrollbar-thumb {
  background: #D1D1D1;
  border-radius: 3px;
}

.notice-content::-webkit-scrollbar-thumb:hover {
  background: #B8B8B8;
}
</style>
